var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-learn-question-answer"},[(
      _vm.ELEMENT_TYPES.ABC_OPTIONS_TEST === _vm.SOURCE_TO_ELEMENT[_vm.currentELementType]
    )?_c('LLearnABCOptionsTest',_vm._g({},_vm.$listeners)):_vm._e(),(
      _vm.ELEMENT_TYPES.ABC_EXPLAIN_TEST === _vm.SOURCE_TO_ELEMENT[_vm.currentELementType]
    )?_c('LLearnABCExplainTest',_vm._g({},_vm.$listeners)):_vm._e(),(
      _vm.ELEMENT_TYPES.EXPLAIN_TEST === _vm.SOURCE_TO_ELEMENT[_vm.currentELementType]
    )?_c('LLearnWholeTalk',_vm._g({},_vm.$listeners)):_vm._e(),(_vm.ELEMENT_TYPES.AUDIO_TEST === _vm.SOURCE_TO_ELEMENT[_vm.currentELementType])?_c('LLearVoiceTest',{on:{"next":_vm.onNext}}):_vm._e(),(_vm.ELEMENT_TYPES.AUDIO_READ === _vm.SOURCE_TO_ELEMENT[_vm.currentELementType])?_c('LLearAudioRead',{on:{"next":_vm.onNext}}):_vm._e(),(
      _vm.ELEMENT_TYPES.LISTEN_REPEAT_TEST ===
      _vm.SOURCE_TO_ELEMENT[_vm.currentELementType]
    )?_c('LLearnFoloowRead',{on:{"next":_vm.onNext}}):_vm._e(),(
      _vm.ELEMENT_TYPES.SELF_READING_TEST ===
      _vm.SOURCE_TO_ELEMENT[_vm.currentELementType]
    )?_c('LLearnSelfRead',{on:{"next":_vm.onNext}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }